export default "__VITE_ASSET__CnBW8oOw__"